import { render, staticRenderFns } from "./RecuperarRegistro.vue?vue&type=template&id=53618bf0&scoped=true"
import script from "./RecuperarRegistro.vue?vue&type=script&lang=js"
export * from "./RecuperarRegistro.vue?vue&type=script&lang=js"
import style0 from "./RecuperarRegistro.vue?vue&type=style&index=0&id=53618bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53618bf0",
  null
  
)

export default component.exports